/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Image_HintInputs */



/**
* | output |
* | --- |
* | "webp, png or jpeg — 1MB max." |
*
* @param {Promo_Image_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_image_hint = /** @type {((inputs?: Promo_Image_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Image_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("webp, png ou jpeg — 1 Mo max.")
	if (locale === "es") return /** @type {LocalizedString} */ ("webp, png o jpeg — 1MB máx.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("webp, png ou jpeg — 1MB máx.")
	if (locale === "it") return /** @type {LocalizedString} */ ("webp, png o jpeg — max 1MB.")
	return /** @type {LocalizedString} */ ("webp, png or jpeg — 1MB max.")
});